import { createSlice } from "@reduxjs/toolkit";

export const ImplantSlice = createSlice({
    name: "Implant",
    initialState: {
        ImplantVal: {
        },
    },
    reducers: {
        implantValue: (state, action) => {
            state.ImplantVal = action.payload;
        },

    },
});

export const { implantValue } = ImplantSlice.actions;

export default ImplantSlice.reducer;